<div class="persons-root" *ngIf="loading; else list">
  <!-- placeholder -->
  <ng-container *ngIf="showPlaceholder">
    <div class="persons-wrapper persons-placeholder">
      <div class="person-box person-box-shadow">
          <div class="role-box">
              <qm-person-role-icon class="role-icon"></qm-person-role-icon>
              <span class="role-desc">&hellip;</span>
          </div>
          <div class="details-box">
              <span>{{ 'Loading...' | translate }}</span>
          </div>
          <div class="click-to-call">
              <qm-click-to-call></qm-click-to-call>
          </div>
      </div>
    </div>
  </ng-container>
</div>
<ng-template #list>
  <!-- actual list -->
  <ng-container *ngIf="(filteredPersonnelData$ | async).length > 0">
      <div class="persons-wrapper">
          <div class="person-box person-box-shadow" *ngFor="let person of (filteredPersonnelData$ | async)">
              <div class="role-box">
                  <ng-container [ngSwitch]="person.role">
                      <qm-person-role-icon class="role-icon" *ngSwitchCase="'LEAD'" [number]="1"></qm-person-role-icon>
                      <qm-person-role-icon class="role-icon" *ngSwitchCase="'ASSIST'" [number]="2"></qm-person-role-icon>
                      <qm-person-role-icon class="role-icon" *ngSwitchDefault></qm-person-role-icon>
                  </ng-container>
                  <span class="role-desc">{{ person.roleDesc }}</span>
              </div>
              <div class="details-box">
                  <span>ID: {{ person.personId }}</span>
                  <span>{{ person.fromStation }} - {{ person.toStation }}</span>
              </div>
              <div class="click-to-call">
                  <qm-click-to-call [personId]="person.personId"></qm-click-to-call>
              </div>
          </div>
      </div>
      <button
          *ngIf="(currentPersonnelData | async).length > 2"
          (click)="toggleViewOpen()">
          {{ (expanded$ | async) ? ('Collapse' | translate) : ('Expand' | translate) }}
          <fa-icon [icon]="(expanded$ | async) ? 'caret-up' : 'caret-down'"></fa-icon>
      </button>
    </ng-container>
</ng-template>
